import { Action } from 'redux'

import ClientFlightInterface from '../../interfaces/client/Flight'
import ClientPassengerInterface from '../../interfaces/client/Passenger'

import { REQUEST_FLIGHT } from '../../actions/flights/requestFlight'
import { RECEIVE_FLIGHT } from '../../actions/flights/receiveFlight'
import { FETCH_PASSENGERS } from '../../actions/passengers/fetchPassengers'
import { PASSENGERS_FETCHED } from '../../actions/passengers/passengersFetched'
import { REQUEST_DELETE_PASSENGERS } from '../../actions/passengers/requestDeletePassengers'
import { RECEIVE_DELETE_PASSENGERS } from '../../actions/passengers/receiveDeletePassengers'
import { VALIDATE_DELETE_PASSENGERS } from '../../actions/passengers/validateDeletePassengers'
import { SET_PASSENGERS_TO_BE_DELETED } from '../../actions/deletePassengers/setPassengersToBeDeleted'
import { CREATE_BOOKING } from '../../actions/bookings/createBooking'
import { SET_DELETE_PASSENGER_FROM_SINGLE_FLIGHT } from '../../actions/deletePassengers/setDeletePassengersFromSingleFlight'
import { SET_DELETE_PASSENGER_FROM_MULTIPLE_FLIGHTS } from '../../actions/deletePassengers/setDeletePassengersFromMultipleFlights'

export interface RequestsAction extends Action {
  flightId: string
  flight: ClientFlightInterface
  passengers: ClientPassengerInterface[]
  passengerIds: string[]
  deletePassengersFromSingleFlight: boolean
}

export interface RequestsState {
  isFetchingFlights: string[]
  isFetchingPassengers: string[]
  isValidatingPassengersBeforeRemoving: boolean
  isRemovingPassengers: boolean
  isRequestingPassengers: boolean
  deletePassengersFromSingleFlight: boolean
}

export const initialState: RequestsState = {
  isFetchingFlights: [],
  isFetchingPassengers: [],
  isValidatingPassengersBeforeRemoving: false,
  isRemovingPassengers: false,
  isRequestingPassengers: false,
  deletePassengersFromSingleFlight: false,
}

export default (
  state = initialState,
  action: RequestsAction = {
    type: '',
    flightId: '',
    flight: {
      flightId: '',
      flightNumber: '',
      route: '',
      origin: '',
      originCode: '',
      destination: '',
      destinationCode: '',
      arrivalDate: '',
      arrivalDay: '',
      arrivalTime: '',
      departureDate: '',
      departureDay: '',
      departureTime: '',
      travelClassSeatCounts: [],
    },
    passengers: [],
    passengerIds: [],
    deletePassengersFromSingleFlight: false,
  }
) => {
  switch (action.type) {
    case REQUEST_FLIGHT:
      return {
        ...state,
        isFetchingFlights: [...state.isFetchingFlights, action.flightId],
      }
    case RECEIVE_FLIGHT:
      return {
        ...state,
        isFetchingFlights: state.isFetchingFlights.filter(
          (flightId: string) => flightId !== action.flight.flightId
        ),
      }
    case CREATE_BOOKING:
      return {
        ...state,
        isFetchingPassengers: [
          ...state.isFetchingPassengers,
          ...action.passengers.map(
            (passenger: ClientPassengerInterface) => passenger.id
          ),
        ],
      }
    case PASSENGERS_FETCHED:
      return {
        ...state,
        isFetchingPassengers: state.isFetchingPassengers.filter(
          (passengerId: string) =>
            !action.passengers
              .map((passenger: ClientPassengerInterface) => passenger.id)
              .includes(passengerId)
        ),
        isRequestingPassengers: false,
      }

    case FETCH_PASSENGERS:
      return {
        ...state,
        isRequestingPassengers: true,
      }

    case VALIDATE_DELETE_PASSENGERS:
      return {
        ...state,
        isValidatingPassengersBeforeRemoving: true,
      }
    case SET_PASSENGERS_TO_BE_DELETED:
      return {
        ...state,
        isValidatingPassengersBeforeRemoving: false,
      }

    case REQUEST_DELETE_PASSENGERS:
      return {
        ...state,
        isRemovingPassengers: true,
      }
    case RECEIVE_DELETE_PASSENGERS:
      return {
        ...state,
        isRemovingPassengers: false,
      }
    case SET_DELETE_PASSENGER_FROM_SINGLE_FLIGHT:
      return {
        ...state,
        deletePassengersFromSingleFlight: true,
      }
    case SET_DELETE_PASSENGER_FROM_MULTIPLE_FLIGHTS:
      return {
        ...state,
        deletePassengersFromSingleFlight: false,
      }
    default:
      return state
  }
}
